import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import detector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    keySeparator: false,
    supportedLngs: ["es", "en"],
    backend: {
      loadPath: (lng: any, ns: any) => {
        switch (ns) {
          case "common":
            return `/locales/${lng}/common.json`;
          default:
            return `/locales/${lng}/${ns}.json`;
        }
      },
    },
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: ["es", "en"],
  });

export default i18n;
